(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesdiaController', VentamesdiaController);

    VentamesdiaController.$inject = [
		"$scope",
		"$filter",
		"$state",
		"Ventamesdia",
		"VentamesdiaFecha",
		"ParseLinks",
		"AlertService"
		];

    function VentamesdiaController($scope,  $filter, $state, Ventamesdia, VentamesdiaFecha,  ParseLinks,  AlertService) {
        var vm = this;
		vm.transition = transition;
		vm.fromDate = null;
		vm.toDate = null;
		vm.onChangeDate = onChangeDate;
		vm.previousMonth = previousMonth;
		vm.today = today;
        vm.listaComercios = null;
		vm.seleccionComercio = "<Todos>";
		vm.arrayComercios = null;
		vm.totalizado= 0.00;
		 
		vm.toDate=JSON.parse( sessionStorage.getItem( 'ventasmesdiafechahasta'), dateReviver );
		vm.fromDate=JSON.parse( sessionStorage.getItem( 'ventasmesdiafechadesde'), dateReviver );
		if ((typeof vm.toDate == 'undefined') || (vm.toDate == null)){
			vm.today();	
		}
		if ((typeof vm.fromDate == 'undefined') || (vm.fromDate == null)){
			vm.previousMonth();
		}
		//
		vm.onChangeDate();
		//
		$scope.today = function() {
		  $scope.dt = new Date();
		};
		$scope.today();

		$scope.clear = function() {
		  $scope.dt = null;
		};

		$scope.inlineOptions = {
		  customClass: getDayClass,
		  minDate: new Date(),
		  showWeeks: true
		};

		//aca llamaban a disabled para sacar los weekends...
		$scope.dateOptions = {
		  formatYear: "yy",
		  maxDate: new Date(2040, 12, 31),
		  minDate: new Date(2018, 8, 1),
		  startingDay: 1
		};

		// Disable weekend selection (no lo usamos!)
		function disabled(data) {
		  var date = data.date,
			mode = data.mode;
		  return mode === "day" && (date.getDay() === 0 || date.getDay() === 6);
		}

		$scope.toggleMin = function() {
		  $scope.inlineOptions.minDate = $scope.inlineOptions.minDate
			? null
			: new Date();
		  $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
		};

		$scope.toggleMin();

		$scope.open1 = function() {
		  $scope.popup1.opened = true;
		};

		$scope.open2 = function() {
		  $scope.popup2.opened = true;
		};

		$scope.setDate = function(year, month, day) {
		  $scope.dt = new Date(year, month, day);
		};

		$scope.formats = ["dd-MMMM-yyyy", "yyyy/MM/dd", "dd.MM.yyyy", "shortDate"];
		$scope.format = $scope.formats[0];
		$scope.altInputFormats = ["M!/d!/yyyy"];

		$scope.popup1 = {   opened: false  };

		$scope.popup2 = {   opened: false  };

		var tomorrow = new Date();
		tomorrow.setDate(tomorrow.getDate() + 1);
		var afterTomorrow = new Date();
		afterTomorrow.setDate(tomorrow.getDate() + 1);
		$scope.events = [
		  {
			date: tomorrow,
			status: "full"
		  },
		  {
			date: afterTomorrow,
			status: "partially"
		  }
		];

		function getDayClass(data) {
		  var date = data.date,
			mode = data.mode;
		  if (mode === "day") {
			var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

			for (var i = 0; i < $scope.events.length; i++) {
			  var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

			  if (dayToCheck === currentDay) {
				return $scope.events[i].status;
			  }
			}
		  }

		  return "";
		}

		
		function onChangeDate() {
		  var dateFormat = "yyyy-MM-dd";
		  var fromDate = $filter("date")(vm.fromDate, dateFormat);
		  var toDate = $filter("date")(vm.toDate, dateFormat);

		  if (fromDate > toDate) {
			AlertService.error(
			  "Fecha Hasta debe ser mayor o igual que Fecha Desde"
			);
			return false;
		  }
		  
		  sessionStorage.setItem( 'ventasmesdiafechadesde', JSON.stringify(new Date(vm.fromDate)));
		  sessionStorage.setItem('ventasmesdiafechahasta', JSON.stringify(new Date(vm.toDate)));
		  
		  //aca llama al service.js y de ahi al WS backend
		  VentamesdiaFecha.query(
			{ fromDate: fromDate, toDate: toDate },
			function(result) {
				vm.listaComercios= new Map();
				vm.totalizado=0;
				result.forEach(function(vtadia){
						//vtadia.total = Math.round((vtadia.total/1.21) * 100) / 100;	//DIVIDIMOS POR IVA21 para tener el neto!!
						vtadia.total = Math.round(vtadia.total-(vtadia.tax1a+vtadia.tax1b));	//DIVIDIMOS POR IVA21 para tener el neto!!
						vm.totalizado += (vtadia.total);						
						if(!vm.listaComercios.has(vtadia.comercio)){				//https://codeburst.io/javascript-array-distinct-5edc93501dc4
							vm.listaComercios.set(vtadia.comercio, true);    // set any value to Map
							}
						})  
				vm.arrayComercios = Array.from(vm.listaComercios.keys());//console.log(vm.arrayComercios);
				vm.arrayComercios.sort();
				vm.arrayComercios.unshift("<Todos>");
				vm.ventamesdias = result;
			}
		  );
		}

		function transition() {
		  $state.transitionTo($state.$current, {
		  });
		}

		// Date picker configuration
		function today() {
		  // Today + 1 day - needed if the current day must be included
		  var today = new Date();
		  vm.toDate = new Date(
			today.getFullYear(),
			today.getMonth(),
			today.getDate()
		  ); //+1 seria manana
		}

		function previousMonth() {
		  var fromDate = new Date();
		  if (fromDate.getMonth() === 0) {
			fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
		  } else {
			fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1); //fromDate.getDate());
		  }

		  vm.fromDate = fromDate;
		}
		
		//exportacion a Excel/CSV
		var mystyle = {
			  sheetid: 'VentasMesDia',
			  headers:false, 
			  caption: {
				  title:'VentasMesDia',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {3:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};
		
		alasql.fn.mydateformat = function(value) {
            //var date = new Date(value);
            //return date.toLocaleDateString();
			if (value !== "") {
                var effectiveDate = new Date(value);
                var month = effectiveDate.getMonth() + 1;
                var date = effectiveDate.getDate();
                var year = effectiveDate.getFullYear();
                return date + "-" + month + "-" + year;
            } else {
                return ""
            }
        };
			
		var cenComercial = "SHOPPING";
		
		var fixedcolumn_NomTVenta = "TOTAL";		
		var dateFormat = "dd-MM-yyyy";
		var emptyColumn = "";
		var fechadesde = $filter("date")(vm.fromDate, dateFormat);
		var fechahasta = $filter("date")(vm.toDate, dateFormat);
		var nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
		var nomcoContrato="Contrato";
		var nomcoFecha="Fecha";
		var nomcoAlicuota="Alicuota";
		var nomcoTVenta="T.Venta";
		var nomcoCantidad="Cantidad";
		var nomcoItems="Items";
		var nomcoImporte="Importe";
		var nomcoObservaciones="Observaciones";
		var nomcoCenCom="Cen.Com.";
		var nomcoLocal="Local";
		var nomcoNomComercial="Nom.Comercial";
		var nomcoRazonSocial="Razon Social";
		var nomcoNomTVenta="Nom/T.Venta";
		
		vm.exportDataExcel = function () {
			
			vm.vtamesdiafiltrada = angular.copy(vm.ventamesdias.filter($scope.filtraPorComercio));			
			
			if(soloUnComercio()==true){
				//nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio_' + $scope.vm.seleccionComercio.replace(/\s+/g, '-');
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio(' + vm.vtamesdiafiltrada[0].comercio.replace(/\s+/g, '-') + ')_RazonSocial(' + vm.vtamesdiafiltrada[0].razonsocial.replace(/\s+/g, '-') + ')_Contrato(' +  vm.vtamesdiafiltrada[0].contrato + ')';
				}
			else {
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
				}
			
			alasql('select * INTO XLSX("VentaMesDia_'+ nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all SELECT cast(contrato as NUMBER) as Contrato, mydateformat(fecha) as Fecha, 1 as Alicuota, 1 as [T.Venta], tickets as Cantidad, total as Importe, ? as Observaciones, ? as  [Cen.Com.], nrolocal as Local, comercio as [Nom.Comercial], razonsocial as [Razon Social], ? as [Nom/T.Venta] \
				FROM ?)', 
				[mystyle, emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn, nomcoContrato,nomcoFecha,nomcoAlicuota,nomcoTVenta,nomcoCantidad,nomcoImporte,nomcoObservaciones,nomcoCenCom,nomcoLocal, nomcoNomComercial,nomcoRazonSocial,nomcoNomTVenta,emptyColumn, cenComercial, fixedcolumn_NomTVenta, vm.vtamesdiafiltrada]);
			
			
			};
		
		vm.exportDataExcelFull = function () {
			
			vm.vtamesdiafiltrada = angular.copy(vm.ventamesdias.filter($scope.filtraPorComercio));			
			
			if(soloUnComercio()==true){
				//nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio_' + $scope.vm.seleccionComercio.replace(/\s+/g, '-');
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio(' + vm.vtamesdiafiltrada[0].comercio.replace(/\s+/g, '-') + ')_RazonSocial(' + vm.vtamesdiafiltrada[0].razonsocial.replace(/\s+/g, '-') + ')_Contrato(' +  vm.vtamesdiafiltrada[0].contrato + ')';
				}
			else {
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
				}				
		
			alasql('select * INTO XLSX("VentaMesDiaFull_'+ nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?, ?,?,?,?, ?,?,?,? \
				union all SELECT cast(contrato as NUMBER) as Contrato, mydateformat(fecha) as Fecha, 1 as Alicuota, 1 as [T.Venta], tickets as Cantidad, items as Items, total as Importe, ? as Observaciones, ? as  [Cen.Com.], nrolocal as Local, comercio as [Nom.Comercial], razonsocial as [Razon Social], ? as [Nom/T.Venta] \
				FROM ?)', 
				[mystyle, nomcoContrato,nomcoFecha,nomcoAlicuota,nomcoTVenta,nomcoCantidad,nomcoItems,nomcoImporte,nomcoObservaciones,nomcoCenCom,nomcoLocal, nomcoNomComercial,nomcoRazonSocial,nomcoNomTVenta,emptyColumn, cenComercial, fixedcolumn_NomTVenta,vm.vtamesdiafiltrada]);
			
			};
		
		vm.exportDataCSV = function () {
			
			vm.vtamesdiafiltrada = angular.copy(vm.ventamesdias.filter($scope.filtraPorComercio));			
			
			if(soloUnComercio()==true){
				//nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio_' + $scope.vm.seleccionComercio.replace(/\s+/g, '-');
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio(' + vm.vtamesdiafiltrada[0].comercio.replace(/\s+/g, '-') + ')_RazonSocial(' + vm.vtamesdiafiltrada[0].razonsocial.replace(/\s+/g, '-') + ')_Contrato(' +  vm.vtamesdiafiltrada[0].contrato + ')';
				}
			else {
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
				}				
					
			alasql('select * INTO CSV("VentaMesDia_'+ nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all SELECT contrato as Contrato, mydateformat(fecha) as Fecha, 1 as Alicuota, 1 as [T.Venta], tickets as Cantidad, total as Importe, ? as Observaciones, ? as  [Cen.Com.], nrolocal as Local, comercio as [Nom.Comercial], razonsocial as [Razon Social], ? as [Nom/T.Venta] \
				FROM ?)', 
				[mystyle, emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn, nomcoContrato,nomcoFecha,nomcoAlicuota,nomcoTVenta,nomcoCantidad,nomcoImporte,nomcoObservaciones,nomcoCenCom,nomcoLocal, nomcoNomComercial,nomcoRazonSocial,nomcoNomTVenta,emptyColumn, cenComercial, fixedcolumn_NomTVenta, vm.vtamesdiafiltrada]);
			
			};	

			
		//para storage de Date's
		function dateReviver( key, value ) {
			if ( isSerializedDate( value ) ) {
				return( new Date( value ) );
			}
			// If it's not a date-string, we want to return the value as-is. If we fail to return
			// a value, it will be omitted from the resultant data structure.
			return( value );
		}


		// I determine if the given value is a string that matches the serialized-date pattern.
		function isSerializedDate( value ) {
			// Dates are serialized in TZ format, example: '1981-12-20T04:00:14.000Z'.
			var datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
			return( isString( value ) && datePattern.test( value ) );
		}

		// I determine if the given value is a String.
		function isString( value ) {
			return( {}.toString.call( value ) === "[object String]" );
		}

		
		function soloUnComercio()
		{
		if( !vm.seleccionComercio ||	!vm.seleccionComercio.length)
			return false;
		if("<Todos>" === vm.seleccionComercio)
			return false;
		return true;
		}
		  
		$scope.calcTotal = function(comercio){
			if( !$scope.vm.seleccionComercio ||	!$scope.vm.seleccionComercio.length)
				return 0;
			vm.totalizado=0;
			if( !vm.ventadetalles ||	!vm.ventadetalles.length)
				return 0;		
			var maxl=vm.ventamesdias.length;
			if("<Todos>" === $scope.vm.seleccionComercio){
				for (var i = 0; i < maxl; i++) { 
					var zet = vm.ventamesdias[i];
					vm.totalizado += zet.total;
					}
				return vm.totalizado;
				}
			//
			for (var i = 0; i < maxl; i++) { 
				var zet = vm.ventamesdias[i];
				if(zet.comercio === $scope.vm.seleccionComercio){
					vm.totalizado += zet.total;
					}
				}
			return vm.totalizado;
		}
		
		$scope.filtraPorComercio = function (ventamesdia) {
			if( !$scope.vm.seleccionComercio ||	!$scope.vm.seleccionComercio.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionComercio){
				return true;
				}
			if(ventamesdia.comercio === $scope.vm.seleccionComercio){
				return true;
				}	
			return false;
		}
    }
})();